
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import dayjs from "dayjs";
import ReturnCard from "./components/return-card.vue";
import { addCurrencyUnit, formDownload } from "@common/src/utils/tools";
import DataImport from "@common/src/components/scope/data-import/index.vue";
import ImportPackageCard from "./components/import-package-card.vue";
import NoticeChannel from "@common/src/components/scope/notice-channel/index.vue";
import TextTips from "@common/src/components/scope/text-tips/index.vue";
import t from "@common/src/i18n/t";

const service = namespace("service");
const base = namespace("base");
const purchase = namespace("purchase");
const marketing = namespace("marketing");
@Component({
  components: { ReturnCard, DataImport, ImportPackageCard, NoticeChannel, TextTips }
})
@Table.DataImport({
  templateUrl: "https://static.gtech.asia/static/speedbiz/import/储值卡导入.xlsx",
  actionUrl: "/filecloud/importDepositCard"
})
@Table("loadListData")
export default class ServiceList extends Vue {
  dayjs = dayjs;
  @base.Action getDictionaryList;
  @marketing.Action queryCardList;
  @marketing.Action saveCardChangeNotice;
  @purchase.Action purchaseComplete;
  @marketing.Action queryCardChangeNoticeChannel;
  @service.Action createInvoice;
  @purchase.Action createPurchasePayment;
  @purchase.Mutation setPaymentBtnLoading;
  @purchase.Mutation setMakeInvoiceBtnLoading;
  @base.Action jumpPrintPage;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  orderList: any[] = [];
  activeRow: any = {};
  cardCode = null;
  searchForm = {
    cardName: "",
    cardType: "",
    cardStatus: "",
    customerName: "",
    mobile: "",
    plateCode: "",
    dataTime: "",
    openTimeBegin: "",
    openTimeEnd: ""
  };
  totalObj = {
    totalCardAmount: "1", //总开卡金额（total card amount）
    totalCardCount: "2", //总开卡张数（total card count）
    totalCardSurplusCount: "", //卡剩余使用次数（card surplus count）
    totalCardholdersNumber: "", //总开卡人数（total cardholders number）
    totalGiftAmount: "", //总赠送金额（total gift amount）
    totalSurplusAmount: "" //总账面剩余金额（total surplus amount）
  };
  showComfirmPayment: boolean = false;
  showRegisterInvoice: boolean = false;
  orderStatusList: any[] = [];
  staffList: any[] = [];
  get showNoticeChannelSet() {
    return this.$route.params.showNoticeChannelSet === "1";
  }
  handleInvoiceConfirmClick(data) {
    this.setMakeInvoiceBtnLoading(true);
    this.createInvoice(data)
      .then(() => {
        this.$message.success(t("purchase.invoice-register-success") as string);
        this.showRegisterInvoice = false;
        this.loadListData();
      })
      .finally(() => {
        this.setMakeInvoiceBtnLoading(false);
      });
  }
  created() {
    this.init();
    this.loadListData();
  }
  cardTemplateTypeList: any = [];
  cardStatusList: any = [];
  init() {
    this.getDictionaryList("card_type").then(data => {
      this.cardTemplateTypeList = data;
    });
    this.getDictionaryList("card_status").then(data => {
      this.cardStatusList = data;
    });

    if (this.showNoticeChannelSet) {
      this.showCardChangeNotify = true;
    }
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryCardList({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = data.data.list;
      let arr = ["totalCardAmount", "totalGiftAmount", "totalSurplusAmount"];
      let brr = ["totalCardCount", "totalCardholdersNumber", "totalCardSurplusCount"];
      arr.forEach(ele => {
        this.totalObj[ele] = data.data[ele];
      });
      brr.forEach(ele => {
        this.totalObj[ele] = this.extractInteger(data.data[ele]);
      });
      return data;
    });
  }
  handleSwitchStatus() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  handleShowPackageCard() {
    (this.$refs["import-package-card"] as any).mix_handleShowImportModal();
  }
  get searchList() {
    return [
      {
        label: t("marketing.card-name"),
        type: "input",
        value: "",
        prop: "cardName"
      },
      {
        label: "marketing.card-type",
        type: "select",
        value: "",
        selectList: this.cardTemplateTypeList,
        prop: "cardType"
      },
      {
        label: t("marketing.card-status"),
        type: "select",
        value: "",
        selectList: this.cardStatusList,
        prop: "cardStatus"
      },
      {
        label: "finance.guest-names",
        type: "input",
        value: "",
        prop: "customerName"
      },
      {
        label: t("v210801.customer-mobile-number"),
        type: "input",
        value: "",
        prop: "mobile"
      },
      {
        label: t("v212.available-vehicles"),
        type: "input",
        value: "",
        prop: "plateCode"
      },
      {
        label: t("v210906.card-opening-time"),
        type: "daterange",
        value: "",
        prop: "dataTime"
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "dataTime") {
          this.searchForm["openTimeBegin"] = item.value ? item.value[0] : "";
          this.searchForm["openTimeEnd"] = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  handleLinkOrderView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  handleReturn(row) {
    this.activeRow = row;
    this.cardCode = row.cardCode;
    this.$nextTick(() => {
      const refs = this.$refs.returnCard as any;
      refs.showRefundModalFn();
    });
  }
  returnFn() {
    this.loadListData();
  }
  showCardChangeNotify: boolean = false;
  handleShowCardChangeNotify() {
    this.showCardChangeNotify = true;
  }
  handleSaveCardChangeSet() {
    this.saveCardChangeNotice({
      notifyMethods: this.changeSetForm.notifyMethods
    }).then(() => {
      this.$message.success(t("v210831.saved-successfully"));
      this.showCardChangeNotify = false;
    });
  }
  selectchannel: any = [];
  changeSetForm: any = {
    notifyMethods: ""
  };
  previewImg: any = require("@/assets/img/card-change-sms.png");
  handleSetOpen() {
    this.queryCardChangeNoticeChannel().then(data => {
      this.selectchannel = data.data.notifyMethods;
    });
  }
  handleToAddCar(command, row) {
    if (command === "addCar") {
      const { href } = this.$router.resolve(`/setting/customer-add?customerCode=${row.customerCode}`);
      window.open(href);
    }
  }
  handleExportData() {
    formDownload(`${window.API_URL}/card/export`, this.searchForm);
  }
  extractInteger(str) {
    if (str === "") {
      return "-";
    }

    const parts = str.split(".");
    const integerPart = parts[0];

    return integerPart;
  }
  handlePrint(row) {
    this.jumpPrintPage({
      category: "PRINT_CARD_DETAIL",
      documentNo: row.cardCode
    });
  }
}
